import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        // Base: hairline border, no offset ring. A soft transition lets
        // the focus glow grow in instead of snapping.
        "flex h-10 w-full rounded-md border border-border bg-background px-3 py-2 text-sm transition-shadow duration-200 ease-out",
        "placeholder:text-muted-foreground",
        // Focus: keep the same hairline border (no thick outline), tint
        // it sunset, and grow a translucent shadow ring around it. The
        // shadow uses color-mix on --color-primary so it adapts to
        // light/dark theme automatically.
        "focus-visible:outline-none",
        "focus-visible:border-primary/45",
        "focus-visible:shadow-[0_0_0_4px_color-mix(in_oklch,var(--color-primary)_14%,transparent)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
